var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "a-modal",
    {
      attrs: {
        title: _vm.title,
        width: 870,
        visible: _vm.visible,
        "ok-text": "保存",
      },
      on: { ok: _vm.handleOk, cancel: _vm.handleCancel },
    },
    [
      [
        _c("WangEditor", {
          attrs: { editorStyle: { minHeight: "300px" } },
          model: {
            value: _vm.form.comment,
            callback: function ($$v) {
              _vm.$set(_vm.form, "comment", $$v)
            },
            expression: "form.comment",
          },
        }),
      ],
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }